import { BooleanInput } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import {
  FuseConfirmationConfig,
  FuseConfirmationService,
} from '@fuse/services/confirmation';
import { UserRecord } from '@libs/shared/api';
import { AvatarComponent } from '@libs/shared/ui/avatar/avatar.component';
import { AvatarFileKeyPipe } from '@libs/shared/utils/pipe/avatar-file-key/avatar-file-key.pipe';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthUserProfile } from '@sprint-expert/app/core/auth/auth-user-profile';
import { AuthService } from '@sprint-expert/app/core/auth/auth.service';
import { injectCoreFeature } from '@sprint-expert/app/core/state/core.service';
import { UserService } from '@sprint-expert/app/core/user/user.service';
import { Observable, Subject } from 'rxjs';

@UntilDestroy()
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'user',
  templateUrl: './user.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'user',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    AvatarComponent,
    MatDividerModule,
    AvatarFileKeyPipe,
  ],
})
export class UserComponent implements OnDestroy {
  core = injectCoreFeature();

  /* eslint-disable @typescript-eslint/naming-convention */
  static ngAcceptInputType_showAvatar: BooleanInput;
  /* eslint-enable @typescript-eslint/naming-convention */

  @Input() showAvatar = true;
  user$: Observable<UserRecord>;
  keycloakUser$: Observable<AuthUserProfile>;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _router: Router,
    private _userService: UserService,
    private _authService: AuthService,
    private _fuseConfirmationService: FuseConfirmationService
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------
  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Sign out
   */
  signOut(): void {
    const dialogConfig = {
      title: '로그아웃',
      message: '정말 로그아웃 할까요?',
    } as FuseConfirmationConfig;
    const dialogRef = this._fuseConfirmationService.open(dialogConfig);

    dialogRef
      .afterClosed()
      .pipe(untilDestroyed(this))
      .subscribe(result => {
        if (result === 'confirmed') {
          this._authService.logout();
        }
      });
  }
  copyIdToClipboard(): void {
    navigator.clipboard.writeText(this.core.currentUser$$().id);
  }
}
